import { render, staticRenderFns } from "./add-maintenance.vue?vue&type=template&id=324f0ef1&scoped=true"
import script from "./add-maintenance.vue?vue&type=script&lang=js"
export * from "./add-maintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324f0ef1",
  null
  
)

export default component.exports